'use es6';

import { addHandlers } from './handlers';
export default function initDirectionalityPlugin(editor) {
  addHandlers(editor);
}